/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Comment_SuccessInputs */

const en_ticket_action_comment_success = /** @type {(inputs: Ticket_Action_Comment_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment sent.`)
};

const ja_ticket_action_comment_success = /** @type {(inputs: Ticket_Action_Comment_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントを送信しました。`)
};

const fr_ticket_action_comment_success = /** @type {(inputs: Ticket_Action_Comment_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaire envoyé.`)
};

const de_ticket_action_comment_success = /** @type {(inputs: Ticket_Action_Comment_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar gesendet.`)
};

/**
* | output |
* | --- |
* | "Comment sent." |
*
* @param {Ticket_Action_Comment_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_comment_success = /** @type {((inputs?: Ticket_Action_Comment_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Comment_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_comment_success(inputs)
	if (locale === "ja") return ja_ticket_action_comment_success(inputs)
	if (locale === "fr") return fr_ticket_action_comment_success(inputs)
	return de_ticket_action_comment_success(inputs)
});